import { Component, Input, Output, EventEmitter } from "@angular/core";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: "app-quick-search-popup",
  templateUrl: "./quick-search-popup.component.html",
  styleUrls: ["./quick-search-popup.component.css"]
})
export class QuickSearchPopupComponent {
  @Input() width = 400;
  @Input() placeholder: string;
  @Output() searchEntered = new EventEmitter<string>();

  popupVisible = false;
  searchValue: string = null;

  constructor(public languageService: LanguageService) {}

  onSearch() {
    this.searchEntered.emit(this.searchValue);
    this.popupVisible = false;
  }
}
